import { default as settings } from './settings';
import { default as state } from './state';
import { default as store } from './store';

export {
  settings,
  state,
  store
};



// WEBPACK FOOTER //
// ./src/resources/index.js